import { useMutation } from '@tanstack/react-query';
import { exportFolderGuidelines } from '../api/folders.api';
import { notificationService } from '@/lib/services/notification.service';
import { downloadFile } from '@/shared/utils/downloadFile';
import { useTranslation } from 'react-i18next';

interface ExportFolderGuidelinesParams {
  folderId: string;
}

export const useExportFolderGuidelines = () => {
  const { t } = useTranslation('knowledge');

  return useMutation<undefined, Error, ExportFolderGuidelinesParams>({
    mutationFn: async ({ folderId }: ExportFolderGuidelinesParams) => {
      const { blob, fileName } = await exportFolderGuidelines(folderId);
      const url = window.URL.createObjectURL(blob);
      await downloadFile({
        url,
        mimeType: 'text/plain',
        fileName,
      });
    },
    onError: (error) => {
      notificationService.showError(
        error.message || t('guidelines.useExportFolderGuidelines.failedToExportGuidelines'),
      );
    },
  });
};
